// MindAR 타깃(.mind) 컴파일 — 책 페이지 그림/사진을 브라우저에서 인식 데이터로 만든다(FR-AR-01).
// window.MINDAR 전역 등록형 번들(동적 로드). BookEditor·ArOverlayEditor 공용.
import { uploadAsset } from "./contentApi";

interface MindarCompiler {
  compileImageTargets(images: HTMLImageElement[], onProgress: (p: number) => void): Promise<unknown>;
  exportData(): Promise<ArrayBuffer>;
}

async function loadCompiler(): Promise<new () => MindarCompiler> {
  await import("mind-ar/dist/mindar-image.prod.js"); // window.MINDAR.IMAGE 등록(부수효과)
  const g = window as unknown as { MINDAR?: { IMAGE?: { Compiler?: new () => MindarCompiler } } };
  const C = g.MINDAR?.IMAGE?.Compiler;
  if (!C) throw new Error("compiler_missing");
  return C;
}

/** File → HTMLImageElement(로드 완료). objectURL 은 호출부가 revoke. */
export function fileToImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("이미지를 읽지 못했어요"));
    };
    img.src = url;
  });
}

/** URL(같은 그림) → HTMLImageElement. R2 는 CORS(*) 라 crossOrigin 으로 픽셀 읽기 가능(캔버스 오염 없음). */
export function imageFromUrl(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("페이지 그림을 불러오지 못했어요(먼저 저장했나요?)"));
    img.src = url;
  });
}

/** 이미지 → .mind 컴파일 → R2 업로드 → URL. onProgress 0~100. */
export async function compileTarget(
  targetKey: string,
  img: HTMLImageElement,
  name: string,
  onProgress: (p: number) => void,
): Promise<string> {
  const Compiler = await loadCompiler();
  const compiler = new Compiler();
  onProgress(0);
  await compiler.compileImageTargets([img], (p) => onProgress(Math.round(p)));
  const buf = await compiler.exportData();
  const mind = new File([buf], `${name}.mind`, { type: "application/octet-stream" });
  return uploadAsset(targetKey, mind);
}
